import { SelectItemGroup } from "primeng/api";

export const APP_VERSION: string = "2.3.4";
export const LANGS: Array<{label: string, code: string}> = [{ label: 'Italiano', code: 'it' }, { label: 'English', code: 'en' }];
export const AIModels: SelectItemGroup[] = []; // this is populated by the API call in the Chatbots Component
export const CDN_URL: string = "https://cdn.shopchat.it";